var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-collaborator-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [_vm._v("Eklenecek İşbirlikçiler")]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            staticStyle: { width: "100%" },
            attrs: { mode: "multiple", placeholder: "Kullanıcılar seçin" },
            on: { change: _vm.emitChange },
            model: {
              value: _vm.localConfig.userList,
              callback: function ($$v) {
                _vm.$set(_vm.localConfig, "userList", $$v)
              },
              expression: "localConfig.userList",
            },
          },
          _vm._l(_vm.users, function (user) {
            return _c(
              "a-select-option",
              { key: user._id, attrs: { value: user._id } },
              [
                _vm._v(
                  "\n                " + _vm._s(user.name) + "\n            "
                ),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }